import React from 'react';
import { useViewportState } from './ViewportStateProvider';

export const LazyMount: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { hasEntered } = useViewportState();
  if (!hasEntered) {
    return null;
  }
  return <>{children}</>;
};
